import { IntlMessageFormat } from 'intl-messageformat';
import { createI18n } from 'vue-i18n';

const translations = import.meta.glob('@translations/*.json', { eager: true });
const messages = Object.fromEntries(
    Object.entries(translations).map(([path, { default: json }]) => {
        const locale = path.match(/php_([a-z]{2}).json$/)[1];
        return [locale, json];
    })
);

const messageCompiler = (message, { locale, key, onError }) => {
    if (typeof message === 'string') {
        const formatter = new IntlMessageFormat(message, locale);
        return (ctx) => {
            return formatter.format(ctx.values);
        };
    } else {
        onError && onError(new Error('not support for AST'));
        return () => key;
    }
};

const i18n = createI18n({
    legacy: false,
    locale: document.documentElement.getAttribute('lang') ?? 'de',
    messages,
    messageCompiler,
    messageResolver: (obj, path) => {
        const msg = obj[`site.${path}`];
        return msg != null ? msg : null;
    },
});

export default i18n;
